export default __webpack_public_path__ + "static/josh brodbeck-45f2db55f656aa86b90302fa464ae6db.webp";